<template>
    <div class="wos__page_index">
        <div class="container-fluid">
            <section class="wos__page-content_index">
                <div class="release" v-if="$releaseText">
                    <p class="release-text noselect">{{$releaseText}}</p>
                </div>
                <img src="/assets/images/wos__logo.svg" alt="Wellis Online System logo" width="205">
                <h1 class="mt-5 mb-3 ml-2" ref="mainTitle">404</h1>
                <div class="row">
                    <div class="col-md-3 col-sm-12">
                        <p>{{$t('components.httpnotfound.text')}}</p>
                        <router-link :to="{name:'app.start'}" class="color-gold">{{$t('components.httpnotfound.return')}}</router-link>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HttpNotFound"
    }
</script>

<style scoped>
    .release {
        top: 0;
        left: 5%;
    }
</style>
